import { ButtonBase, Stack, styled } from '@mui/material';

export const Container = styled('div')(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  gap: '8px',
  width: '100%',
}));

export const CommentHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
  width: '100%',
}));

export const HeaderSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  alignSelf: 'stretch',
  gap: '6px',
  width: '100%',
  flexWrap: 'wrap',
}));

export const UserName = styled('p')(() => ({
  margin: 0,
  color: '#504E5A',
  textAlign: 'center',
  fontFamily: '"Neue Frutiger World", sans-serif',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '150%',
}));

export const TimeAgo = styled('p')(() => ({
  margin: 0,
  color: '#615E6F',
  textAlign: 'center',
  fontFamily: '"Neue Frutiger World", sans-serif',
  fontSize: '10px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
}));

export const ContentSection = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '2px',
  alignSelf: 'stretch',
  flex: 1,
  minWidth: 0,
}));

export const BodyText = styled('div')(({ theme }) => ({
  alignSelf: 'stretch',
  width: '100%',
  margin: 0,
  color: 'var(--Typography-h-secondary, #504E5A)',
  fontFamily: '"Neue Frutiger World", sans-serif',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  wordBreak: 'break-word',

  '& div': {
    backgroundColor: 'transparent !important',

    '& p': {
      margin: 0,
      fontSize: '12px !important',
      lineHeight: '160% !important',
      color: `${theme.palette.accent.main} !important`,
      fontFamily: '"Neue Frutiger World", sans-serif !important',
      fontWeight: '400 !important',
    },
  },

  '& p': {
    margin: 0,
  },

  '& span': {
    fontFamily: '"Neue Frutiger World", sans-serif',
    fontSize: '12px',
    lineHeight: '160%',
  },
}));

export const ContentFooter = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  alignSelf: 'stretch',
  flexWrap: 'wrap',
  gap: '12px',
}));

export const FooterButton = styled(ButtonBase)(({ theme }) => ({
  display: 'inline-flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '4px',
  padding: 0,
  cursor: 'pointer',
  color: '#615E6F',

  '&:hover': {
    backgroundColor: 'transparent',
    color: theme.palette.grey[700],
  },
}));

export const FooterButtonText = styled('p')(() => ({
  margin: 0,
  color: '#615E6F',
  textAlign: 'center',
  fontFamily: '"Neue Frutiger World", sans-serif',
  fontSize: '10px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
}));

export const UserTypeChip = styled('span')<{ bgColor: string; textColor: string }>(
  ({ bgColor, textColor }) => ({
    display: 'flex',
    padding: '0.25rem 0.375rem',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.5rem',
    backgroundColor: bgColor,
    color: textColor,
    textAlign: 'center',
    fontFamily: '"Neue Frutiger World", sans-serif',
    fontSize: '0.5625rem',
    fontWeight: 400,
    lineHeight: '100%',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  }),
);

export const ChipsWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
}));

export const RepliesList = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  gap: '12px',
  width: '100%',
  marginTop: '12px',
}));
